// removed by extract-text-webpack-plugin
module.exports = {"content":"PatientInformationSheet__content__2ofSV","parentContainer":"PatientInformationSheet__parentContainer__1WLHZ","ant-carousel":"PatientInformationSheet__ant-carousel__2yPYE","slick-slide":"PatientInformationSheet__slick-slide__yyQph"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PatientInformationSheet/PatientInformationSheet.css
// module id = 288
// module chunks = 0